import { decoratedText } from "@/components/Markdown/mentions.ts"
import { ReasoningResult_Message } from "@/components/ReasoningStep/ReasoningResult_Message.tsx"
import { TerminalDialog } from "@/components/ReasoningStep/TerminalDialog.tsx"

import type { UIToolCallObservation } from "@/lib/client/generated/TypeDefinitions.ts"

export const ReasoningResult_SshCommand = (props: {
  content: UIToolCallObservation.SshCommand,
  taskId: string,
  inProgress: boolean
}) => {
  let message: string
  if (props.content.message.value.length > 0) {
    message = props.content.message.value
  } else if (props.content.exitCode === 0) {
    message = `Executed command \`${props.content.command}\`.`
  } else if (props.content.exitCode !== null && props.content.exitCode !== undefined) {
    message = `Failed to execute command \`${props.content.command}\`. Exit code: ${props.content.exitCode}.`
  } else {
    message = `Executing command \`${props.content.command}\``
  }

  return (
    <TerminalDialog
      execResultId={props.content.execResultId}
      taskId={props.taskId}
      commandId={props.content.commandId ?? undefined}
      previewId={props.content.previewId ?? undefined}
    >
      <ReasoningResult_Message
        content={{ message: decoratedText(message), icon: "TERMINAL", className: "Message" }}
        inProgress={props.inProgress}
      />
    </TerminalDialog>
  )
}